export const STEP = {
  TIME: "time",
  DATE: "date",
};
